// Timer.js (update to apply styling)
import React, { useState, useEffect } from 'react';
import { timerStyles } from './paymentInfo.tailwind';
import {useNavigate} from 'react-router-dom';
import routeConstant from '../../../lib/constants/routeConstant';
import { getCurrentTimestamps } from '../../../lib/utils/dateAndTimeFormatting';

const Timer = ({ endTime }) => {
  const navigate=useNavigate();
  
  const [timeLeft, setTimeLeft] = useState(endTime - getCurrentTimestamps());

  useEffect(() => {
    const interval = setInterval(() => {
      // measure remaining time 
      const remainingTime= endTime - getCurrentTimestamps();

      setTimeLeft(remainingTime);

      if(!remainingTime || remainingTime <= 0){
        clearInterval(interval);
        navigate(routeConstant.CART_PAGE);
      }
    }, 1000);

    // clear interval - on unmounting
    return () => clearInterval(interval);
  }, [endTime, navigate]);

  const formatTimeLeft = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);                           // seconds
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');         // hours
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');// minutes
    const seconds = String(totalSeconds % 60).padStart(2, '0');                     // seconds
    return `${hours > 0 ? `${hours}:` : ''}${minutes} : ${seconds}`;                // return { hours:minutes:seconds }
  };

  return (
    <div className={timerStyles.container}>
      {timeLeft > 0 ? formatTimeLeft(timeLeft) : `Time's up!`}
    </div>
  );
};

export default Timer;
